import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Card } from 'primereact/card';
import { Col, Container, Row } from "reactstrap";
import axios from 'axios';
import Logo from '../../../assets/images/ats-logo.png';
import Swal from 'sweetalert2';
import { useForm } from 'react-hook-form';
import { TextField, Typography,IconButton,InputAdornment,FormControl} from "@mui/material";

const RegistrationPage = () => {
    const navigate = useNavigate();
    const triggerAlert = (icon, title, message) => {
        return Swal.fire({
            icon: icon,
            title: title,
            text: message,
            timer: 3000,
        });
    };
    const [Loader,setLoader]=useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { register, handleSubmit, getValues, formState: { errors }, trigger, watch } = useForm();
    
    const onSubmit = async (data) => {
        setLoader(true);
        const payload = {
            company_name: data.companyName,
            company_email: data.companyEmail,
            company_phone: data.companyPhone,
            company_address: data.companyAddress,
            domain: data.companyDomain,
            website: data.website,
            description: data.description,
            year_founded: Number(data.yearFounded),
            specialties: data.specialties,
            contact_first_name: data.firstName,
            contact_last_name: data.lastName,
            contact_email: data.email,
            contact_phone: data.phoneNumber,
            contact_designation: data.designation,
            contact_address: data.contactAddress,
            password: data.password,
            confirm_password: data.confirmPassword
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/company/register-company/`,
                payload
            );

            if (response.status === 200 || response.status === 201) {
                triggerAlert("success", "Success", "Company successfully registered");
                navigate("/", { replace: true });
                setLoader(false);
            }
        } catch (error) {
            const err = error.response?.data?.message || "Registration failed.";
            triggerAlert("warning", "Warning", err);
            setLoader(false);
        }
    };


    return (
        <div className="flex justify-content-center align-items-center min-h-screen login-page">
            <Card style={{ width: '50rem' }} className='login-card'>
                <div className="flex justify-content-center align-items-center ">
                    <img src={Logo} width="150" height="64" className='mb-2' />
                </div>
                <Col lg={12}>
                    <h3 className='login-head mb-3 mt-3 text-center'>Register Company</h3>
                </Col>
                <div className="p-fluid">
                    <form onSubmit={handleSubmit(onSubmit)}>

                        {/* ------------------- COMPANY DETAILS ------------------- */}

                        <Row className="mb-3">
                            <Col lg={6}>
                                <label>Company Domain <span style={{ color: "red", fontWeight: 800 }}>*</span></label>
                                <InputText
                                    {...register("companyDomain", {
                                        required: "Company domain is required",
                                        pattern: {
                                            value: /^[a-zA-Z0-9-]+$/,
                                            message: "Only letters, numbers and hyphens allowed"
                                        }
                                    })}
                                    placeholder="company-domain"
                                    className={errors.companyDomain ? "p-invalid" : ""}
                                    disabled={Loader}
                                />
                                {errors.companyDomain && <small className="p-error">{errors.companyDomain.message}</small>}
                            </Col>

                            <Col lg={6}>
                                <label>Company Name <span style={{ color: "red", fontWeight: 800 }}>*</span></label>
                                <InputText
                                    {...register("companyName", {
                                        required: "Company name is required",
                                        pattern: {
                                            value: /^[A-Za-z][A-Za-z ]*$/,
                                            message: "Only letters allowed, cannot start with space"
                                        }
                                    })}
                                    placeholder="Company Name"
                                    className={errors.companyName ? "p-invalid" : ""}
                                    disabled={Loader}
                                />
                                {errors.companyName && <small className="p-error">{errors.companyName.message}</small>}
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg={6}>
                                <label>Company Email <span style={{ color: "red", fontWeight: 800 }}>*</span></label>
                                <InputText
                                    {...register("companyEmail", {
                                        required: "Company email is required",
                                        pattern: {
                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                            message: "Invalid email"
                                        }
                                    })}
                                    placeholder="Company Email"
                                    className={errors.companyEmail ? "p-invalid" : ""}
                                    disabled={Loader}
                                />
                                {errors.companyEmail && <small className="p-error">{errors.companyEmail.message}</small>}
                            </Col>

                            <Col lg={6}>
                                <label>Company Phone <span style={{ color: "red", fontWeight: 800 }}>*</span></label>
                                <InputText
                                    {...register("companyPhone", {
                                        required: "Phone number is required",
                                        pattern: {
                                            value: /^\+?[0-9]{7,15}$/,
                                            message: "Enter valid phone with 7-15 digits"
                                        }
                                    })}
                                    placeholder="Company PhoneNumber"
                                    className={errors.companyPhone ? "p-invalid" : ""}
                                    disabled={Loader}
                                />
                                {errors.companyPhone && <small className="p-error">{errors.companyPhone.message}</small>}
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg={6}>
                                <label>Company Address <span style={{ color: "red", fontWeight: 800 }}>*</span></label>
                                <InputText
                                    {...register("companyAddress", {
                                        required: "Address is required",
                                        pattern: {
                                            value: /^[^\s].*$/,
                                            message: "Address cannot start with a space"
                                        }
                                    })}
                                    placeholder="Address"
                                    className={errors.companyAddress ? "p-invalid" : ""}
                                    disabled={Loader}
                                />
                                {errors.companyAddress && <small className="p-error">{errors.companyAddress.message}</small>}
                            </Col>

                            <Col lg={6}>
                                <label>Website</label>
                                <InputText
                                    {...register("website", {
                                        pattern: {
                                            value: /^(https?:\/\/)?([\w\-])+(\.[\w\-]+)+[/#?]?.*$/,
                                            message: "Enter a valid URL"
                                        }
                                    })}
                                    placeholder="Website"
                                    disabled={Loader}
                                />
                                {errors.website && <small className="p-error">{errors.website.message}</small>}
                            </Col>
                        </Row>

                        {/* ------------------- EXTRA COMPANY DETAILS ------------------- */}

                        <Row className="mb-3">
                            <Col lg={6}>
                                <label>Description</label>
                                <InputText
                                    {...register("description", {
                                        pattern: {
                                            value: /^[^\s].*$/,
                                            message: "Cannot start with a space"
                                        }
                                    })}
                                    placeholder="Company Description"
                                    disabled={Loader}
                                />
                            </Col>

                            <Col lg={6}>
                                <label>Specialties</label>
                                <InputText
                                    {...register("specialties", {
                                        pattern: {
                                            value: /^[^\s].*$/,
                                            message: "Cannot start with a space"
                                        }
                                    })}
                                    placeholder="Specialties"
                                    disabled={Loader}
                                />
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg={6}>
                                <label>Year Founded</label>
                                <InputText
                                    {...register("yearFounded", {
                                        pattern: {
                                            value: /^(19|20)\d{2}$/,
                                            message: "Enter valid year (e.g., 2020)"
                                        }
                                    })}
                                    placeholder="Year Founded"
                                    disabled={Loader}
                                />
                            </Col>

                            <Col lg={6}>
                                <label>Contact Address</label>
                                <InputText
                                    {...register("contactAddress", {
                                        pattern: {
                                            value: /^[^\s].*$/,
                                            message: "Address cannot start with space"
                                        }
                                    })}
                                    placeholder="Contact address"
                                    disabled={Loader}
                                />
                            </Col>
                        </Row>

                        {/* ------------------- CONTACT PERSON DETAILS ------------------- */}

                        <Row className="mb-3">
                            <Col lg={6}>
                                <label>First Name <span style={{ color: "red", fontWeight: 800 }}>*</span></label>
                                <InputText
                                    {...register("firstName", {
                                        required: "First name required",
                                        pattern: {
                                            value: /^[A-Za-z][A-Za-z ]*$/,
                                            message: "Only letters allowed"
                                        }
                                    })}
                                    placeholder="firstName"
                                    className={errors.firstName ? "p-invalid" : ""}
                                    disabled={Loader}
                                />
                                {errors.firstName && <small className="p-error">{errors.firstName.message}</small>}
                            </Col>

                            <Col lg={6}>
                                <label>Last Name <span style={{ color: "red", fontWeight: 800 }}>*</span></label>
                                <InputText
                                    {...register("lastName", {
                                        required: "Last name required",
                                        pattern: {
                                            value: /^[A-Za-z][A-Za-z ]*$/,
                                            message: "Only letters allowed"
                                        }
                                    })}
                                    placeholder="lastName"
                                    className={errors.lastName ? "p-invalid" : ""}
                                    disabled={Loader}
                                />
                                {errors.lastName && <small className="p-error">{errors.lastName.message}</small>}
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg={6}>
                                <label>Email <span style={{ color: "red", fontWeight: 800 }}>*</span></label>
                                <InputText
                                    {...register("email", {
                                        required: "Email is required",
                                        pattern: {
                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                            message: "Invalid email"
                                        }
                                    })}
                                    placeholder="email"
                                    className={errors.email ? "p-invalid" : ""}
                                    disabled={Loader}
                                />
                                {errors.email && <small className="p-error">{errors.email.message}</small>}
                            </Col>

                            <Col lg={6}>
                                <label>Phone Number <span style={{ color: "red", fontWeight: 800 }}>*</span></label>
                                <InputText
                                    {...register("phoneNumber", {
                                        required: "Phone number required",
                                        pattern: {
                                            value: /^\+?[0-9]{7,15}$/,
                                            message: "Invalid phone number"
                                        }
                                    })}
                                    placeholder="PhoneNumber"
                                    className={errors.phoneNumber ? "p-invalid" : ""}
                                    disabled={Loader}
                                />
                                {errors.phoneNumber && <small className="p-error">{errors.phoneNumber.message}</small>}
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col lg={12}>
                                <label>Designation <span style={{ color: "red", fontWeight: 800 }}>*</span></label>
                                <InputText
                                    {...register("designation", {
                                        required: "Designation required",
                                        pattern: {
                                            value: /^[A-Za-z][A-Za-z ]*$/,
                                            message: "Only letters allowed"
                                        }
                                    })}
                                    placeholder="Designation"
                                    className={errors.designation ? "p-invalid" : ""}
                                    disabled={Loader}
                                />
                                {errors.designation && <small className="p-error">{errors.designation.message}</small>}
                            </Col>
                        </Row>

                        {/* ------------------- PASSWORDS ------------------- */}
                        <Row className="mb-3">
                            <Col lg={6}>
                                <FormControl variant="standard" fullWidth >
                                    <Typography variant="body2" gutterBottom>Password <span style={{ color: "red", fontWeight: 800 }}>*</span></Typography>
                                    <TextField
                                        fullWidth
                                        id="password-input"
                                        type={showPassword ? "text" : "password"}
                                        {...register("password", {
                                            required: "Password is required",
                                            pattern: {
                                                value: /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,16}$/,
                                                message: "Password must be 8-16 characters, with at least one digit, one lowercase, and one uppercase letter.",
                                            },
                                        })}
                                        onKeyUp={() => trigger("password")}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                                        {showPassword ? <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eye"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" /></svg> : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eye-off"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M10.585 10.587a2 2 0 0 0 2.829 2.828" /><path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87" /><path d="M3 3l18 18" /></svg>}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        error={!!errors.password}
                                        helperText={errors.password?.message}
                                        onCopy={(e) => e.preventDefault()}
                                        onPaste={(e) => e.preventDefault()}
                                        disabled={Loader}
                                    />
                                </FormControl>
                            </Col>
                            <Col lg={6}>
                                <FormControl variant="standard" fullWidth >
                                    <Typography variant="body2" gutterBottom>Confirm Password <span style={{ color: "red", fontWeight: 800 }}>*</span></Typography>
                                    <TextField
                                        fullWidth
                                        id="confirm-password-input"
                                        type={showConfirmPassword ? "text" : "password"}
                                        {...register("confirmPassword", {
                                            required: "Confirm Password is required",
                                            validate: (value) => value === watch("password") || "Passwords do not match",
                                        })}
                                        onKeyUp={() => trigger("confirmPassword")}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                                                        {showConfirmPassword ? <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eye"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" /><path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" /></svg> : <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-eye-off"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M10.585 10.587a2 2 0 0 0 2.829 2.828" /><path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87" /><path d="M3 3l18 18" /></svg>}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                        error={!!errors.confirmPassword}
                                        helperText={errors.confirmPassword?.message}
                                        onCopy={(e) => e.preventDefault()}
                                        onPaste={(e) => e.preventDefault()}
                                        disabled={Loader}
                                    />
                                </FormControl>

                            </Col>
                        </Row>



                        <Row>
                            <Col lg={12} className="text-center">
                                <Button type="submit" className="btn btn-primary btn-main mb-4" disabled={Loader}>{Loader ? "Registering..." : "Register"}</Button>
                            </Col>
                        </Row>

                    </form>
                  {!Loader &&  <Col lg={12} className='text-center'>
                        <p>Already have an account? <span style={{ color: 'blue', cursor: 'pointer' }} onClick={() => navigate("/login", { replace: true })}>Login</span></p>
                    </Col>}
                </div>
            </Card>
        </div>
    );
};

export default RegistrationPage;